// REBEL PROOF™ — On-chain diploma section i18n (ES/EN/SK).
export const I18N_DIPLOMA = {
  badge: {
    es: "⛓ REBEL PROOF™ · ON-CHAIN",
    en: "⛓ REBEL PROOF™ · ON-CHAIN",
    sk: "⛓ REBEL PROOF™ · ON-CHAIN", de: "⛓ REBEL PROOF™ · ON-CHAIN", "zh-CN": "⛓ REBEL PROOF™ · ON-CHAIN",
  },
  titulo: {
    es: "Tu diploma en la Blockchain",
    en: "Your diploma on the Blockchain",
    sk: "Tvoj diplom na Blockchaine", de: "Dein Diplom auf der Blockchain", "zh-CN": "您的区块链文凭",
  },
  descripcion: {
    es: "Al completar el curso recibes un certificado digital único registrado permanentemente en la blockchain de Base L2. Verificable por cualquier persona en el mundo, imposible de falsificar.",
    en: "Upon completing the course you receive a unique digital certificate permanently registered on the Base L2 blockchain. Verifiable by anyone in the world, impossible to falsify.",
    sk: "Po dokončení kurzu dostanete jedinečný digitálny certifikát trvalo zaregistrovaný na blockchaine Base L2. Overiteľný kýmkoľvek na svete, nedá sa sfalšovať.", de: "Nach Abschluss des Kurses erhältst du ein einzigartiges digitales Zertifikat, das dauerhaft auf der Base L2 Blockchain registriert ist. Von jedem Menschen weltweit verifizierbar, unmöglich zu fälschen.", "zh-CN": "完成课程后，您将获得一份独特的数字证书，永久记录在Base L2区块链上。全球任何人都可以验证，无法伪造。",
  },
  puntos: {
    es: [
      "🔒 Registrado on-chain — permanente e inmutable",
      "✓ Verificable públicamente en rebelbtc.com/verify",
      "₿ Primer diploma cripto con prueba blockchain real",
    ],
    en: [
      "🔒 Registered on-chain — permanent and immutable",
      "✓ Publicly verifiable at rebelbtc.com/verify",
      "₿ First crypto diploma with real blockchain proof",
    ],
    sk: [
      "🔒 Zaregistrované on-chain — trvalé a nemenné",
      "✓ Verejne overiteľné na rebelbtc.com/verify",
      "₿ Prvý krypto diplom s reálnym blockchain dôkazom",
    ], de: ["🔒 On-chain registriert — permanent und unveränderlich", "✓ Öffentlich verifizierbar auf rebelbtc.com/verify", "₿ Erstes Krypto-Diplom mit echter Blockchain-Proof"], "zh-CN": ["🔒 链上记录——永久且不可篡改", "✓ 可在rebelbtc.com/verify公开验证", "₿ 首个具有真实区块链证明的加密文凭"],
  },
  verEjemplo: {
    es: "Ver ejemplo de diploma →",
    en: "See diploma example →",
    sk: "Zobraziť príklad diplomu →", de: "Beispieldiplom ansehen →", "zh-CN": "查看文凭示例 →",
  },
  cerrar: {
    es: "✕ Cerrar",
    en: "✕ Close",
    sk: "✕ Zavrieť", de: "✕ Schließen", "zh-CN": "✕ 关闭",
  },
  // Diploma SVG localized strings
  diploma: {
    academia: {
      es: "ACADEMIA",
      en: "ACADEMY",
      sk: "AKADÉMIA", de: "AKADEMIE", "zh-CN": "学院",
    },
    certificaQue: {
      es: "CERTIFICA QUE",
      en: "CERTIFIES THAT",
      sk: "POTVRDZUJE, ŽE", de: "BESTÄTIGT, DASS", "zh-CN": "特此证明",
    },
    haCompletado: {
      es: "ha completado exitosamente",
      en: "has successfully completed",
      sk: "úspešne dokončil/a", de: "erfolgreich abgeschlossen hat", "zh-CN": "已成功完成",
    },
    fechaEmision: {
      es: "FECHA DE EMISIÓN",
      en: "ISSUE DATE",
      sk: "DÁTUM VYDANIA", de: "AUSSTELLUNGSDATUM", "zh-CN": "颁发日期",
    },
    fechaValor: {
      es: "Junio, 2026",
      en: "June, 2026",
      sk: "Jún, 2026", de: "Juni, 2026", "zh-CN": "2026年6月",
    },
    emisionLabel: {
      es: "EMISIÓN",
      en: "ISSUED",
      sk: "VYDANIE", de: "AUSGABE", "zh-CN": "颁发",
    },
    firmaDigital: {
      es: "FIRMA DIGITAL",
      en: "DIGITAL SIGNATURE",
      sk: "DIGITÁLNY PODPIS", de: "DIGITALE SIGNATUR", "zh-CN": "数字签名",
    },
    directorAcademico: {
      es: "DIRECTOR ACADÉMICO",
      en: "ACADEMIC DIRECTOR",
      sk: "AKADEMICKÝ RIADITEĽ", de: "AKADEMISCHER DIREKTOR", "zh-CN": "学术总监",
    },
    hashOnChain: {
      es: "HASH ON-CHAIN:",
      en: "ON-CHAIN HASH:",
      sk: "ON-CHAIN HASH:", de: "ON-CHAIN HASH:", "zh-CN": "链上哈希：",
    },
    certificadoMeta: {
      es: "CERTIFICADO #000001 · BLOCK #18.492.037",
      en: "CERTIFICATE #000001 · BLOCK #18,492,037",
      sk: "CERTIFIKÁT #000001 · BLOCK #18 492 037", de: "ZERTIFIKAT #000001 · BLOCK #18.492.037", "zh-CN": "证书 #000001 · 区块 #18.492.037",
    },
    footerVerificado: {
      es: "VERIFICADO EN BASE L2 BLOCKCHAIN · rebelbtc.com/verify",
      en: "VERIFIED ON BASE L2 BLOCKCHAIN · rebelbtc.com/verify",
      sk: "OVERENÉ NA BASE L2 BLOCKCHAINE · rebelbtc.com/verify", de: "VERIFIZIERT AUF BASE L2 BLOCKCHAIN · rebelbtc.com/verify", "zh-CN": "已在BASE L2区块链验证 · rebelbtc.com/verify",
    },
  },
};

export const getDiplomaI18n = (lang) => {
  const L = ["es", "en", "sk", "de", "zh-CN"].includes(lang) ? lang : "en";
  return {
    badge: I18N_DIPLOMA.badge[L],
    titulo: I18N_DIPLOMA.titulo[L],
    descripcion: I18N_DIPLOMA.descripcion[L],
    puntos: I18N_DIPLOMA.puntos[L],
    verEjemplo: I18N_DIPLOMA.verEjemplo[L],
    cerrar: I18N_DIPLOMA.cerrar[L],
    diploma: {
      academia: I18N_DIPLOMA.diploma.academia[L],
      certificaQue: I18N_DIPLOMA.diploma.certificaQue[L],
      haCompletado: I18N_DIPLOMA.diploma.haCompletado[L],
      fechaEmision: I18N_DIPLOMA.diploma.fechaEmision[L],
      fechaValor: I18N_DIPLOMA.diploma.fechaValor[L],
      emisionLabel: I18N_DIPLOMA.diploma.emisionLabel[L],
      firmaDigital: I18N_DIPLOMA.diploma.firmaDigital[L],
      directorAcademico: I18N_DIPLOMA.diploma.directorAcademico[L],
      hashOnChain: I18N_DIPLOMA.diploma.hashOnChain[L],
      certificadoMeta: I18N_DIPLOMA.diploma.certificadoMeta[L],
      footerVerificado: I18N_DIPLOMA.diploma.footerVerificado[L],
    },
  };
};
